
export default function MetricsTable({ rows }){
  return (
    <div className="table-wrap">
      <table>
        <thead>
          <tr><th>Algorithm</th><th>Speed</th><th>Robustness</th><th>Resource Use</th><th>Composite Score</th></tr>
        </thead>
        <tbody>
          {rows.map((r)=> (
            <tr key={r.alg}>
              <td>{r.alg}</td>
              <td>{r.speed}</td>
              <td>{r.robust}</td>
              <td>{r.resource}</td>
              <td>{r.composite}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}
